import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, isRef as _isRef, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withKeys as _withKeys, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "p-d-flex p-flex-column p-jc-between p-flex-sm-row" }
const _hoisted_2 = { class: "p-input-icon-left p-mb-1" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-search" }, null, -1)
const _hoisted_4 = ["for"]

import { computed, ref } from "vue";
import { useDeleteProduct } from "@/graphql/product/delete.product";
import { useProducts, useProductsFilter } from "@/graphql/product/products";
import { subscriptionExpired } from "@/plugins/i18n";
import UpdateProduct from "@/components/product/UpdateProduct.vue";
import { Category, EAccessMenu, Product } from "@/graphql/types";
import {
  CONSTANTS,
  getImage,
  getPrices,
  getPurchasePrices,
  totalStock,
} from "@/graphql/utils/utils";
import CategoryMultiSelect from "@/components/category/CategoryMultiSelect.vue";
import { canNavigateAnywhere, getAccess } from "@/utils/activity";


export default /*#__PURE__*/_defineComponent({
  __name: 'ProductList',
  props: {
    categories: { default: () => [] }
  },
  setup(__props: any) {



const rowsPerPageOptions = CONSTANTS.rowsPerPageOptions;
const updateDialog = ref(false);
const selected = ref<Product>(null);
const acc = getAccess(EAccessMenu.Product);
const noRestriction = canNavigateAnywhere();
const notExpired = !subscriptionExpired();
const { loading, products } = useProducts();
const { removeLoading, submitDelete } = useDeleteProduct();
const {
  filters,
  clearFilter,
  visibleColumns,
  productColumns,
  onChangeVisible,
  priceMatchModeOptions,
} = useProductsFilter();

const permissions = computed(() => {
  return {
    canUpdate: (acc?.update || noRestriction) && notExpired,
    canDelete: (acc?.delete || noRestriction) && notExpired,
  };
});

function updateProduct(id: number) {
  selected.value = products.value.find((prod) => prod.id === id);
  updateDialog.value = true;
}

function prodTable(prod: readonly Product[]) {
  return prod.map((prod) => ({
    ...prod,
    quantity: totalStock(prod.stocks),
    sellingPrices: getPrices(prod),
    purchasePrices: getPurchasePrices(prod),
    createdAt: new Date(prod.createdAt),
  }));
}

return (_ctx: any,_cache: any) => {
  const _component_Button = _resolveComponent("Button")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_MultiSelect = _resolveComponent("MultiSelect")!
  const _component_Image = _resolveComponent("Image")!
  const _component_Avatar = _resolveComponent("Avatar")!
  const _component_Column = _resolveComponent("Column")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_NumberFormatter = _resolveComponent("NumberFormatter")!
  const _component_InputNumber = _resolveComponent("InputNumber")!
  const _component_Calendar = _resolveComponent("Calendar")!
  const _component_DataTable = _resolveComponent("DataTable")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_DataTable, {
      value: prodTable(_unref(products)),
      rows: 20,
      class: "p-datatable-gridlines p-datatable-sm",
      dataKey: "id",
      rowHover: false,
      filters: _unref(filters),
      "onUpdate:filters": _cache[3] || (_cache[3] = ($event: any) => (_isRef(filters) ? (filters).value = $event : null)),
      filterDisplay: "menu",
      loading: _unref(loading),
      responsiveLayout: "scroll",
      globalFilterFields: ['name', 'reference'],
      "rows-per-page-options": _unref(rowsPerPageOptions),
      paginator: "",
      "always-show-paginator": false
    }, {
      header: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_Button, {
            type: "button",
            icon: "pi pi-filter-slash",
            label: _ctx.$t('clear'),
            class: "p-button-outlined p-mb-1",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(clearFilter)()))
          }, null, 8, ["label"]),
          _createElementVNode("span", _hoisted_2, [
            _hoisted_3,
            _createVNode(_component_InputText, {
              placeholder: _ctx.$t('search'),
              style: {"width":"100%"},
              modelValue: _unref(filters)['global'].value,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(filters)['global'].value) = $event))
            }, null, 8, ["placeholder", "modelValue"])
          ]),
          _createVNode(_component_MultiSelect, {
            placeholder: "Colones",
            modelValue: _unref(visibleColumns),
            "onUpdate:modelValue": [
              _cache[2] || (_cache[2] = ($event: any) => (_isRef(visibleColumns) ? (visibleColumns).value = $event : null)),
              _unref(onChangeVisible)
            ],
            options: _unref(productColumns),
            style: {"max-width":"250px"}
          }, {
            option: _withCtx((slotProps) => [
              _createTextVNode(_toDisplayString(_ctx.$t(slotProps.option)), 1)
            ]),
            value: _withCtx(({ value }) => [
              _createTextVNode(_toDisplayString(value.map((x) => _ctx.$t(x)).join(",")), 1)
            ]),
            _: 1
          }, 8, ["modelValue", "onUpdate:modelValue", "options"])
        ])
      ]),
      empty: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$t("noData")), 1)
      ]),
      loading: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$t("loading")), 1)
      ]),
      default: _withCtx(() => [
        (_unref(visibleColumns).includes('image'))
          ? (_openBlock(), _createBlock(_component_Column, {
              key: 0,
              style: {"min-width":"3rem"},
              header: _ctx.$t('image')
            }, {
              body: _withCtx(({ data }) => [
                (data.image)
                  ? (_openBlock(), _createBlock(_component_Image, {
                      key: 0,
                      src: _unref(getImage)(data.image),
                      height: 50,
                      preview: ""
                    }, null, 8, ["src"]))
                  : (_openBlock(), _createBlock(_component_Avatar, {
                      key: 1,
                      label: data.name[0],
                      size: "large"
                    }, null, 8, ["label"]))
              ]),
              _: 1
            }, 8, ["header"]))
          : _createCommentVNode("", true),
        (_unref(visibleColumns).includes('product.reference'))
          ? (_openBlock(), _createBlock(_component_Column, {
              key: 1,
              "show-add-button": false,
              showFilterOperator: false,
              header: _ctx.$t('product.reference'),
              filterField: "reference",
              field: "reference",
              style: {"max-width":"100px"},
              sortable: true,
              "sort-field": "reference"
            }, {
              filter: _withCtx(({ filterModel, filterCallback }) => [
                _createVNode(_component_InputText, {
                  onKeyup: _withKeys(filterCallback, ["enter"]),
                  type: "text",
                  modelValue: filterModel.value,
                  "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
                  class: "p-column-filter",
                  placeholder: _ctx.$t('product.filterByRef')
                }, null, 8, ["onKeyup", "modelValue", "onUpdate:modelValue", "placeholder"])
              ]),
              filterclear: _withCtx(({ filterCallback }) => [
                _createVNode(_component_Button, {
                  type: "button",
                  icon: "pi pi-times",
                  onClick: ($event: any) => (filterCallback()),
                  class: "p-button-warning p-mr-1",
                  label: _ctx.$t('prime.clear')
                }, null, 8, ["onClick", "label"])
              ]),
              filterapply: _withCtx(({ filterCallback }) => [
                _createVNode(_component_Button, {
                  onClick: filterCallback,
                  type: "button",
                  icon: "pi pi-search",
                  class: "p-button-success",
                  label: _ctx.$t('search')
                }, null, 8, ["onClick", "label"])
              ]),
              _: 1
            }, 8, ["header"]))
          : _createCommentVNode("", true),
        (_unref(visibleColumns).includes('product.name'))
          ? (_openBlock(), _createBlock(_component_Column, {
              key: 2,
              "show-add-button": false,
              showFilterOperator: false,
              header: _ctx.$t('product.name'),
              filterField: "name",
              field: "name",
              style: {"min-width":"12rem"},
              sortable: true,
              "sort-field": "name"
            }, {
              filter: _withCtx(({ filterModel, filterCallback }) => [
                _createVNode(_component_InputText, {
                  type: "text",
                  modelValue: filterModel.value,
                  "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
                  onKeyup: _withKeys(filterCallback, ["enter"]),
                  class: "p-column-filter",
                  placeholder: _ctx.$t('product.filterByName')
                }, null, 8, ["modelValue", "onUpdate:modelValue", "onKeyup", "placeholder"])
              ]),
              filterclear: _withCtx(({ filterCallback }) => [
                _createVNode(_component_Button, {
                  type: "button",
                  icon: "pi pi-times",
                  onClick: filterCallback,
                  class: "p-button-warning p-mr-1",
                  label: _ctx.$t('clear')
                }, null, 8, ["onClick", "label"])
              ]),
              filterapply: _withCtx(({ filterCallback }) => [
                _createVNode(_component_Button, {
                  type: "button",
                  icon: "pi pi-search",
                  class: "p-button-success",
                  label: _ctx.$t('search'),
                  onClick: filterCallback
                }, null, 8, ["label", "onClick"])
              ]),
              _: 1
            }, 8, ["header"]))
          : _createCommentVNode("", true),
        (_unref(visibleColumns).includes('product.category'))
          ? (_openBlock(), _createBlock(_component_Column, {
              key: 3,
              showFilterMatchModes: false,
              "show-add-button": false,
              showFilterOperator: false,
              field: "category.label",
              sortable: true,
              "filter-field": "category.id",
              header: _ctx.$t('product.category')
            }, {
              filter: _withCtx(({ filterModel, filterCallback }) => [
                _createVNode(CategoryMultiSelect, {
                  modelValue: filterModel.value,
                  "onUpdate:modelValue": [($event: any) => ((filterModel.value) = $event), ($event: any) => (filterCallback())],
                  items: _ctx.categories,
                  style: {"max-width":"220px"}
                }, null, 8, ["modelValue", "onUpdate:modelValue", "items"])
              ]),
              filterclear: _withCtx(({ filterCallback }) => [
                _createVNode(_component_Button, {
                  type: "button",
                  onClick: ($event: any) => (filterCallback()),
                  class: "p-button-warning p-mr-1 p-button-sm",
                  label: _ctx.$t('prime.clear')
                }, null, 8, ["onClick", "label"])
              ]),
              filterapply: _withCtx(({ filterCallback }) => [
                _createVNode(_component_Button, {
                  label: _ctx.$t('search'),
                  type: "button",
                  icon: "pi pi-search",
                  class: "p-button-sm",
                  onClick: ($event: any) => (filterCallback())
                }, null, 8, ["label", "onClick"])
              ]),
              _: 1
            }, 8, ["header"]))
          : _createCommentVNode("", true),
        (_unref(visibleColumns).includes('product.type'))
          ? (_openBlock(), _createBlock(_component_Column, {
              key: 4,
              "show-filter-match-modes": false,
              header: _ctx.$t('product.type'),
              filterField: "type",
              field: "type",
              style: {"min-width":"12rem"},
              "show-add-button": false,
              "show-filter-operator": false
            }, {
              body: _withCtx(({ data }) => [
                _createTextVNode(_toDisplayString(_ctx.$tm("product.types")[data.type]), 1)
              ]),
              filter: _withCtx(({ filterModel, filterCallback }) => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.$tm('product.types'), (type, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: index,
                    class: "field-radiobutton p-mt-2"
                  }, [
                    _createVNode(_component_Checkbox, {
                      id: `type${index}`,
                      name: "type",
                      value: index,
                      modelValue: filterModel.value,
                      "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
                      onChange: ($event: any) => (filterCallback())
                    }, null, 8, ["id", "value", "modelValue", "onUpdate:modelValue", "onChange"]),
                    _createElementVNode("label", {
                      class: "p-ml-2",
                      for: `type${index}`
                    }, _toDisplayString(type), 9, _hoisted_4)
                  ]))
                }), 128))
              ]),
              filterclear: _withCtx(({ filterCallback }) => [
                _createVNode(_component_Button, {
                  type: "button",
                  icon: "pi pi-times",
                  onClick: ($event: any) => (filterCallback()),
                  class: "p-button-warning p-mr-1",
                  label: _ctx.$t('prime.clear')
                }, null, 8, ["onClick", "label"])
              ]),
              filterapply: _withCtx(({ filterCallback }) => [
                _createVNode(_component_Button, {
                  type: "button",
                  icon: "pi pi-search",
                  onClick: ($event: any) => (filterCallback()),
                  class: "p-button-success",
                  label: _ctx.$t('search')
                }, null, 8, ["onClick", "label"])
              ]),
              _: 1
            }, 8, ["header"]))
          : _createCommentVNode("", true),
        (_unref(visibleColumns).includes('stock.quantity'))
          ? (_openBlock(), _createBlock(_component_Column, {
              key: 5,
              "sort-field": "quantity",
              sortable: true,
              field: "quantity",
              header: _ctx.$t('stock.quantity'),
              "show-add-button": false,
              showFilterOperator: false,
              "filter-field": "quantity",
              dataType: "numeric"
            }, {
              body: _withCtx(({ data }) => [
                _createVNode(_component_NumberFormatter, {
                  value: data.quantity
                }, null, 8, ["value"])
              ]),
              filter: _withCtx(({ filterModel }) => [
                _createVNode(_component_InputNumber, {
                  modelValue: filterModel.value,
                  "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
                  "max-fraction-digits": 20,
                  min: 0,
                  mode: "decimal"
                }, null, 8, ["modelValue", "onUpdate:modelValue"])
              ]),
              filterclear: _withCtx(({ filterCallback }) => [
                _createVNode(_component_Button, {
                  type: "button",
                  onClick: ($event: any) => (filterCallback()),
                  class: "p-button-warning p-button-sm",
                  label: _ctx.$t('prime.clear')
                }, null, 8, ["onClick", "label"])
              ]),
              filterapply: _withCtx(({ filterCallback }) => [
                _createVNode(_component_Button, {
                  label: _ctx.$t('search'),
                  type: "button",
                  icon: "pi pi-search",
                  class: "p-button-sm",
                  onClick: ($event: any) => (filterCallback())
                }, null, 8, ["label", "onClick"])
              ]),
              _: 1
            }, 8, ["header"]))
          : _createCommentVNode("", true),
        (_unref(visibleColumns).includes('product.purchasePrice'))
          ? (_openBlock(), _createBlock(_component_Column, {
              key: 6,
              "show-add-button": false,
              showFilterOperator: false,
              field: "purchasePrices",
              header: _ctx.$t('product.purchasePrice'),
              filterField: "purchasePrices",
              filterMatchModeOptions: _unref(priceMatchModeOptions),
              sortable: true,
              "sort-field": "purchasePrices"
            }, {
              filter: _withCtx(({ filterModel, filterCallback }) => [
                _createVNode(_component_InputNumber, {
                  type: "text",
                  onKeyup: _withKeys(filterCallback, ["enter"]),
                  modelValue: filterModel.value,
                  "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
                  modelModifiers: { number: true },
                  class: "p-column-filter"
                }, null, 8, ["onKeyup", "modelValue", "onUpdate:modelValue"])
              ]),
              filterclear: _withCtx(({ filterCallback }) => [
                _createVNode(_component_Button, {
                  type: "button",
                  icon: "pi pi-times",
                  onClick: ($event: any) => (filterCallback()),
                  class: "p-button-warning",
                  label: _ctx.$t('prime.clear')
                }, null, 8, ["onClick", "label"])
              ]),
              filterapply: _withCtx(({ filterCallback }) => [
                _createVNode(_component_Button, {
                  type: "button",
                  icon: "pi pi-search",
                  onClick: ($event: any) => (filterCallback()),
                  class: "p-button-success p-ml-1",
                  label: _ctx.$t('search'),
                  "icon-pos": "right"
                }, null, 8, ["onClick", "label"])
              ]),
              _: 1
            }, 8, ["header", "filterMatchModeOptions"]))
          : _createCommentVNode("", true),
        (_unref(visibleColumns).includes('product.sellingPrice'))
          ? (_openBlock(), _createBlock(_component_Column, {
              key: 7,
              "show-add-button": false,
              showFilterOperator: false,
              header: _ctx.$t('product.sellingPrice'),
              filterField: "sellingPrices",
              field: "sellingPrices",
              filterMatchModeOptions: _unref(priceMatchModeOptions),
              sortable: true,
              "sort-field": "sellingPrices"
            }, {
              filter: _withCtx(({ filterModel, filterCallback }) => [
                _createVNode(_component_InputNumber, {
                  type: "text",
                  onKeyup: _withKeys(filterCallback, ["enter"]),
                  modelValue: filterModel.value,
                  "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
                  modelModifiers: { number: true },
                  class: "p-column-filter"
                }, null, 8, ["onKeyup", "modelValue", "onUpdate:modelValue"])
              ]),
              filterclear: _withCtx(({ filterCallback }) => [
                _createVNode(_component_Button, {
                  type: "button",
                  icon: "pi pi-times",
                  onClick: ($event: any) => (filterCallback()),
                  class: "p-button-warning",
                  label: _ctx.$t('prime.clear')
                }, null, 8, ["onClick", "label"])
              ]),
              filterapply: _withCtx(({ filterCallback }) => [
                _createVNode(_component_Button, {
                  type: "button",
                  icon: "pi pi-search",
                  onClick: ($event: any) => (filterCallback()),
                  class: "p-button-success p-ml-1",
                  label: _ctx.$t('search'),
                  "icon-pos": "right"
                }, null, 8, ["onClick", "label"])
              ]),
              _: 1
            }, 8, ["header", "filterMatchModeOptions"]))
          : _createCommentVNode("", true),
        (_unref(visibleColumns).includes('createdAt'))
          ? (_openBlock(), _createBlock(_component_Column, {
              key: 8,
              field: "createdAt",
              "show-add-button": false,
              showFilterOperator: false,
              header: _ctx.$t('createdAt'),
              dataType: "date",
              style: {"min-width":"8rem"},
              "filter-field": "createdAt",
              sortable: true,
              "sort-field": "createdAt"
            }, {
              body: _withCtx(({ data }) => [
                _createTextVNode(_toDisplayString(_ctx.$d(data.createdAt)), 1)
              ]),
              filter: _withCtx(({ filterModel, filterCallback }) => [
                _createVNode(_component_Calendar, {
                  modelValue: filterModel.value,
                  "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
                  dateFormat: _ctx.$t('format.calendarDate'),
                  placeholder: _ctx.$t('format.date'),
                  "year-navigator": true,
                  onDateSelect: ($event: any) => (filterCallback())
                }, null, 8, ["modelValue", "onUpdate:modelValue", "dateFormat", "placeholder", "onDateSelect"])
              ]),
              filterclear: _withCtx(({ filterCallback }) => [
                _createVNode(_component_Button, {
                  type: "button",
                  icon: "pi pi-times",
                  onClick: ($event: any) => (filterCallback()),
                  class: "p-button-warning p-mr-1",
                  label: _ctx.$t('prime.clear')
                }, null, 8, ["onClick", "label"])
              ]),
              filterapply: _withCtx(({ filterCallback }) => [
                _createVNode(_component_Button, {
                  type: "button",
                  icon: "pi pi-search",
                  onClick: ($event: any) => (filterCallback()),
                  class: "p-button-success",
                  label: _ctx.$t('search')
                }, null, 8, ["onClick", "label"])
              ]),
              _: 1
            }, 8, ["header"]))
          : _createCommentVNode("", true),
        (_unref(visibleColumns).includes('controls'))
          ? (_openBlock(), _createBlock(_component_Column, {
              key: 9,
              header: _ctx.$t('controls')
            }, {
              body: _withCtx(({ data }) => [
                _createVNode(_component_Button, {
                  style: {"width":"20px","height":"20px"},
                  disabled: !permissions.value.canUpdate,
                  icon: "pi pi-pencil",
                  class: "p-button-success p-button-text p-button-rounded p-mr-2",
                  onClick: ($event: any) => (updateProduct(data.id))
                }, null, 8, ["disabled", "onClick"]),
                _createVNode(_component_Button, {
                  style: {"width":"20px","height":"20px"},
                  icon: "pi pi-trash",
                  class: "p-button-danger p-button-text p-button-rounded",
                  loading: _unref(removeLoading),
                  disabled: !permissions.value.canDelete,
                  onClick: ($event: any) => (_unref(submitDelete)(data.id))
                }, null, 8, ["loading", "disabled", "onClick"])
              ]),
              _: 1
            }, 8, ["header"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["value", "filters", "loading", "rows-per-page-options"]),
    _createVNode(UpdateProduct, {
      categories: _ctx.categories,
      modelValue: updateDialog.value,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((updateDialog).value = $event)),
      src: selected.value?.image ? _unref(getImage)(selected.value?.image, 'products') : '',
      item: selected.value
    }, null, 8, ["categories", "modelValue", "src", "item"])
  ], 64))
}
}

})